import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import DashboardLayout from "../../src/components/DashboardLayout";
import "../styles/ViewAllVendorsCFO.css";
import { useUser } from './Context/UserContext';
import VendorInfoTabs from "./VendorInfoTabs";
const ViewAllVendorsCFO = () => {
    const [approvalHistory, setApprovalHistory] = useState([]); // Change the state name here
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [approvalStatuses, setApprovalStatuses] = useState([]);
    const [comment, setComment] = useState("");
    const [approvalError, setApprovalError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [groupCodeError, setGroupCodeError] = useState("");
    const [accountSetError, setAccountSetError] = useState("");
    const [taxGroupsError, setTaxGroupsError] = useState("");
    const [termsCodeError, setTermsCodeError] = useState("");
    const [departmentTypeError, setDepartmentTypeError] = useState("");
    /* const [suplierTypeError, setSuplierTypeError] = useState("");*/
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [vendorCodeError, setVendorCodeError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [isdError, setIsdError] = useState("");
    const [isSaved, setIsSaved] = useState(false);
    const [isExisting, setIsExisting] = useState(false);
    const [vendorCode, setVendorCode] = useState("");
    const [departments, setDepartments] = useState([]);
    const [supplierTypes, setSupplierTypes] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedSupplierTypeId, setSelectedSupplierTypeId] = useState("");
    const [groupCodes, setGroupCodes] = useState([]);
    const [taxGroups, setTaxGroups] = useState([]);
    const [accountSets, setAccountSets] = useState([]);
    const [isInActive, setIsInActive] = useState(false);
    const [isOnHold, setIsOnHold] = useState(false);
    const [approverId, setApproverId] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(3); // Pending default
    const [searchTerm, setSearchTerm] = useState("");
    const { user: loggedInUser } = useUser();
    const [users, setUsers] = useState([]);
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [backendStatus, setBackendStatus] = useState("3"); // default Pending
    const isReadOnly = backendStatus !== "3";
    useEffect(() => {
        const fetchDropdowns = async () => {
            try {
                const [groupRes, taxRes, accRes] = await Promise.all([
                    axios.get("/api/dropdown/vendorgroups"),
                    axios.get("/api/dropdown/taxgroups"),
                    axios.get("/api/dropdown/accountsets"),
                ]);
                setGroupCodes(groupRes.data || []);
                setTaxGroups(taxRes.data || []);
                setAccountSets(accRes.data || []);
            } catch (err) {
                console.error("Failed to load dropdowns:", err);
            }
        };
        fetchDropdowns();
    }, []);
    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);
    useEffect(() => {
        if (showModal) {
            setActiveTab("details");
        }
    }, [showModal]);
    const handleReviewClick = (index) => {
        const vendor = vendors[index]; //  Declare vendor first
        console.log("Clicked vendor:", vendor); //  Helps confirm structure
        console.log("Clicked vendor full object:", vendor); // <-- Add it here
        setSelectedVendor({
            ...vendor,
            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null, //  Ensure correct userId
            index
        });
        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get("/department/department-id-name"); //  Corrected URL
                console.log("Departments fetched:", res.data);
                setDepartments(res.data);
            } catch (err) {
                console.error("Failed to load departments", err);
            }
        };
        fetchDepartments();
    }, []);
    const handleDepartmentChange = async (e) => {
        const deptId = e.target.value;
        setSelectedVendor(prev => ({ ...prev, departmentType: deptId }));
        setDepartmentTypeError("");
        setSupplierTypes([]); // clear previous
        if (!deptId) return;
        try {
            const res = await axios.get(`/department/${deptId}`);
            const data = (res.data || []).map(s => ({ id: String(s.id), name: s.name }));
            setSupplierTypes(data);
            // Keep previous selected supplier type if it exists
            setSelectedVendor(prev => ({
                ...prev,
                supplierType: prev.supplierType || ""
            }));
        } catch (err) {
            console.error("Error fetching supplier types:", err);
        }
    };
    useEffect(() => {
        if (!selectedVendor?.departmentType) return;
        // fetch supplier types for this department
        axios.get(`/department/${selectedVendor.departmentType}`)
            .then(res => {
                const data = (res.data || []).map(s => ({ id: String(s.id), name: s.name }));
                setSupplierTypes(data);
                // Keep the previously selected supplierType from history
                setSelectedVendor(prev => ({
                    ...prev,
                    supplierType: prev.supplierType || ""
                }));
            })
            .catch(err => console.error("Error fetching supplier types:", err));
    }, [selectedVendor?.departmentType]);
    const statusMapping = {
        Pending: 3,    // pStatusID = 3 → Pending
        Rejected: 2,   // pStatusID = 2 → Rejected
        Approved: 1    // pStatusID = 1 → Approved
    };
    const mapBackendStatusToUI = (status) => {
        // Approved mapped to 1
        if (status === 16) return "1";
        // Rejected mapped to 2
        if ([12, 13, 14, 15].includes(status)) return "2";
        // Otherwise Pending (3)
        return "3";
    };
    const isRejected = selectedVendor?.approvalStatus === "2";
    /*const isDisabledForReject = isRejected || selectedVendor?.isSaved;*/
    useEffect(() => {
        if (selectedStatus !== null) {
            loadVendors(selectedStatus);
        }
    }, [selectedStatus]);
    const loadVendors = async (status) => {
        try {
            if (!user?.empId) {
                console.error("User not loaded yet");
                return;
            }
            const res = await axios.get(
                "/api/vendordetails/details-cfo",
                {
                    params: { statusId: Number(status) }
                }
            );
            if (Array.isArray(res.data) && res.data.length > 0) {
                setVendors(res.data);
            } else {
                setVendors([]); // 👈 ensures UI shows no vendors
            }
        } catch (error) {
            console.error("Error loading CFO vendors:", error);
            setVendors([]); // fallback empty state
        }
    };
    useEffect(() => {
        console.log("Selected Vendor:", selectedVendor);
        if (selectedVendor?.id) {   // ✅ correct condition
            axios
                .get(`/api/approvalstatus/status/${selectedVendor.id}`)
                .then(response => {
                    console.log("Approval History Data:", response.data);
                    setUsers(response.data || []);
                })
                .catch(error => {
                    console.error("Error fetching approval status:", error);
                });
        }
    }, [selectedVendor]);
    const filteredVendors = vendors.filter(vendor =>
        vendor.nameOfCompany?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const vendorsPerPage = 10;
    const startIndex = (currentPage - 1) * vendorsPerPage;
    const endIndex = startIndex + vendorsPerPage;
    const totalPages = Math.ceil(filteredVendors.length / vendorsPerPage);
    const vendorsForPage = filteredVendors.slice(startIndex, endIndex);
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const getStatusStyle = (status) => {
        const text = status || "N/A";
        const lower = text.toLowerCase();

        if (lower.includes("rejected")) {
            return "#c0392b";
        }
        if (lower.includes("pending")) {
            return "#946c00";
        }
        if (lower.includes("approved")) {
            return "#1e7e45";
        }
        return "#6c757d";
    };

    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    console.log("Clicked user:", user);
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA, valueB;
            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }
            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const showCommentHistory =
        backendStatus === "1" || backendStatus === "2";
    const commentsReadOnly = showCommentHistory;
    const rejectionCodeMap = {
        "Finance": "1",
        "Dept Head": "2",
        "PO": "3",
        "Vendor": "4"
    };
    const financeRejectionMap = {
        12: "Finance",
        13: "Dept Head",
        14: "PO",
        15: "Vendor"
    };
    useEffect(() => {
        if (!selectedVendor?.id || !approverId || !showModal) return;
        console.log("⏳ Fetching Vendor History:", selectedVendor.id, approverId);
        axios.get("/api/approvalstatus/vendor-history", {
            params: { vendorId: selectedVendor.id, approverId }
        })
            .then((res) => {
                const d = res.data;
                console.log("Fetched history data:", d);
                const mappedStatus = mapBackendStatusToUI(d.approvalStatus);
                const backendStatusNum = Number(d.approvalStatus);
                const sendToLabel = financeRejectionMap[backendStatusNum];
                const sendToCode = rejectionCodeMap[sendToLabel];
                setBackendStatus(mappedStatus); // ✅ THIS IS THE KEY FIX
                setSelectedVendor(prev => ({
                    ...prev,
                    departmentType: d.departmentTYPE ? Number(d.departmentTYPE) : "",
                    supplierType: d.suppliertype ? String(d.suppliertype) : "",
                    vendorCode: d.vendorCode || "",
                    accountSetCode: d.accountSet || "",
                    taxGroup: d.taxGroups || "",
                    termsCode: d.termsCode || "",
                    inActive: d.inActive === 1,
                    onHold: d.onHold === 1,
                    groupCode: d.groupCode || "",
                    groupName: d.groupName || groupCodes.find(g => g.groupcode === d.groupCode)?.description || "",
                    rejectionSendTo: d.rejectionSendTo || "",
                    isd: d.isd ? Number(d.isd) : "",
                    approvalStatus: mappedStatus,
                    rejectionSendTo: mappedStatus === "2" ? sendToCode || "" : "",
                }));
                setVendorCode(d.vendorCode || "");
                /* setComment(d.approvalComments || "");*/
                if (mappedStatus === "1" || mappedStatus === "2") {
                    setComment(d.approvalComments || "");
                } else {
                    setComment("");
                }
                // ✅ Mark as existing vendor
                setIsExisting(true);
                // 🔒 Set readonly if Approved or Rejected
                /*setIsReadOnly(mappedStatus !== "3");*/  // 3 = Pending → editable, 1/2 = Approved/Rejected → readonly
            })
            .catch(err => console.error("History loading error:", err));
    }, [selectedVendor?.id, approverId, groupCodes, showModal]);
    const handleUpdate = async () => {
        if (!selectedVendor?.id) {
            alert("Vendor not selected!");
            return;
        }
        try {
            const payload = {
                VendorId: selectedVendor.id,
                VendorCode: selectedVendor.vendorCode || "",
                DepartmentType: selectedVendor.departmentType || "",
                SupplierType: selectedVendor.supplierType || "",
                AccountSet: selectedVendor.accountSetCode || "",
                TaxGroups: selectedVendor.taxGroup || "",
                TermsCode: selectedVendor.termsCode || "",
                InActive: selectedVendor.inActive ? 1 : 0,
                OnHold: selectedVendor.onHold ? 1 : 0,
                GroupCode: selectedVendor.groupCode || "",
                GroupName: selectedVendor.groupName || "",
                ISD: selectedVendor.isd || "",
                Comments: comment || ""
            };
            const res = await axios.patch(
                `/api/approvalstatus/cfo-update-vendor/${selectedVendor.id}`,
                payload
            );
            console.log("Vendor updated successfully:", res.data);
            alert("Vendor updated successfully!");
        } catch (err) {
            console.error("Update failed:", err.response?.data || err.message);
            alert("Failed to update vendor! " + (err.response?.data?.details || ""));
        }
    };
    const statusMap = {
        12: "Vendor Rejected by CFO, Pending from Finance",
        13: "Vendor Rejected by CFO, Pending from Dept Head",
        14: "Vendor Rejected by CFO, Pending from PO",
        15: "Vendor Rejected by CFO, Pending from Vendor",
        16: "Vendor Registration Final Approved by CFO",
        1: "Approved",
        2: "Rejected"
    };
    const updateVendorStatusUI = (vendorId, pStatusID, approvalStatus) => {
        // Remove the vendor from current list so it disappears from Pending view
        setVendors(prev => prev.filter(v => v.id !== vendorId));
        setShowModal(false);
        setIsEditing(false);
    };
    const validateForm = () => {
        let isValid = true;
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setGroupCodeError("");
        setAccountSetError("");
        setTaxGroupsError("");
        setTermsCodeError("");
        setDepartmentTypeError("");
        setSupplierTypeError("");
        setVendorCodeError("");
        setIsdError("");
        const uiStatus = mapBackendStatusToUI(selectedVendor?.pStatusID);
        const isPendingVendor = uiStatus === "3"; // Only validate for pending
        const isRejected = selectedVendor?.approvalStatus === "2";
        // 🔴 Skip validation for non-pending vendors
        if (!isPendingVendor) {
            console.log("Validation skipped (not Pending)");
            return;
        }
        /* ===================== COMMON (PENDING ONLY) ===================== */
        if (String(selectedVendor?.approvalStatus) !== "1" &&
            String(selectedVendor?.approvalStatus) !== "2") {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }
        if (typeof comment !== "string" || comment.trim() === "") {
            setCommentError("Comment is required.");
            isValid = false;
        }
        // ✅ If Rejected → Rejection Send To mandatory
        if (selectedVendor?.approvalStatus === "2" && !selectedVendor?.rejectionSendTo) {
            setRejectionSendToError("Please select Rejection Send To");
            isValid = false;
        }
        return isValid;
    };
    const handleSave = async (username, password) => {
        console.log("handleSave called");
        let isValid = true;
        // Clear all errors
        setApprovalStatusError("");
        setCommentError("");
        setRejectionSendToError("");
        setGroupCodeError("");
        setAccountSetError("");
        setTaxGroupsError("");
        setTermsCodeError("");
        setDepartmentTypeError("");
        setSupplierTypeError("");
        setVendorCodeError("");
        setIsdError("");
        const uiStatus = mapBackendStatusToUI(selectedVendor?.pStatusID);
        const isPendingVendor = uiStatus === "3"; // Only validate for pending
        const isRejected = selectedVendor?.approvalStatus === "2";
        // 🔴 Skip validation for non-pending vendors
        if (!isPendingVendor) {
            console.log("Validation skipped (not Pending)");
            return;
        }
        /* ===================== COMMON (PENDING ONLY) ===================== */
        if (String(selectedVendor?.approvalStatus) !== "1" &&
            String(selectedVendor?.approvalStatus) !== "2") {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }
        if (typeof comment !== "string" || comment.trim() === "") {
            setCommentError("Comment is required.");
            isValid = false;
        }
        /* ===================== REJECT (PENDING) ===================== */
        if (isRejected) {
            if (!selectedVendor?.rejectionSendTo) {
                setRejectionSendToError("Rejection send to is required.");
                isValid = false;
            }
            if (!isValid) return;
        }
        /* ===================== APPROVE (PENDING) ===================== */
        if (!isRejected) {
            if (!selectedVendor?.accountSetCode) setAccountSetError("Account Set is required.") && (isValid = false);
            if (!selectedVendor?.taxGroup) setTaxGroupsError("Tax Groups is required.") && (isValid = false);
            if (!selectedVendor?.termsCode) setTermsCodeError("Terms Code is required.") && (isValid = false);
            if (!selectedVendor?.departmentType) setDepartmentTypeError("Department Type is required.") && (isValid = false);
            if (!selectedVendor?.supplierType) setSupplierTypeError("Supplier Type is required.") && (isValid = false);
            if (!selectedVendor?.groupCode) setGroupCodeError("Group Code is required.") && (isValid = false);
            if (!selectedVendor?.isd || selectedVendor.isd === "0") setIsdError("ISD selection is required.") && (isValid = false);
            if (!isValid) return;
        }
        if (!username || !password) {
            alert("Please enter username and password");
            return;
        }
        /* ===================== API CALLS ===================== */
        try {
            let updatedStatusCode = null;
            /* ---------- REJECTION ---------- */
            if (isRejected) {
                const rejectionPayload = {
                    VendorId: selectedVendor.id.toString(),
                    UserId: approverId.toString(),
                    ApprovalStatus: 2,
                    Comments: comment,
                    SendTo: selectedVendor.rejectionSendTo.toString(),
                    SendToName: selectedVendor.rejectionSendToName || ""
                };
                await axios.post(
                    "/api/approvalstatus/update-approval-status",
                    rejectionPayload
                );
                const sendToMap = {
                    "1": 12,
                    "2": 13,
                    "3": 14,
                    "4": 15
                };
                updatedStatusCode = sendToMap[selectedVendor.rejectionSendTo];
            }
            /* ---------- APPROVAL ---------- */
            if (!isRejected) {
                const approvalPayload = {
                    VendorId: selectedVendor.id.toString(),
                    UserId: approverId.toString(),
                    ApprovalStatus: 16,
                    Comments: comment,
                    Username: username,
                    Password: password
                };
                await axios.post(
                    "/api/approvalstatus/authenticate-approve-vendor",
                    approvalPayload
                );
                updatedStatusCode = 16;
            }
            /* ---------- UPDATE UI ---------- */
            setShowModal(false);
            setIsEditing(false);
            alert("Approval submitted successfully");
            await loadVendors(selectedStatus); // ✅ Reload current filter
        } catch (error) {
            console.error("Error submitting approval:", error);
            alert(
                "Failed to submit approval: " +
                (error.response?.data?.title || error.message)
            );
        }
    };
    const handleReject = () => {
        if (!selectedVendor) return;
        const sendToMap = {
            "1": 12, // Finance
            "2": 13, // Dept Head
            "3": 14, // PO
            "4": 15  // Vendor
        };
        const pStatusID = sendToMap[selectedVendor.rejectionSendTo] || 12;
        updateVendorStatusUI(
            selectedVendor.id,
            pStatusID,
            "2" // Rejected
        );
    };
    return (
        <DashboardLayout>
            <div className="vendor-registration-details">
                <Container fluid style={{ marginTop: "-85px", paddingTop: "0" }}>

                    <h2 className="invoice-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '50px' }}> Vendor Details</h2>  
                    {/* 🔹 Search & Filter Row */}
                    <div
                        className="vendor-toolbar"
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            marginBottom: "20px",
                        }}
                    >
                        {/* LEFT CORNER - SEARCH */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div
                                className="vendor-search-box invoice-search-box"
                                style={{
                                    width: "350px",
                                }}
                            >
                                <span className="vendor-search-icon">
                                    🔍
                                </span>

                                <Input
                                    type="text"
                                    placeholder="Search by Company Name..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    className="vendor-search-input"
                                />
                            </div>
                        </div>

                        {/* RIGHT CORNER - STATUS */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <span style={{ whiteSpace: "nowrap" }}>
                                Approved Status:
                            </span>

                            <select
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{
                                    width: "180px",
                                    height: "36px",
                                }}
                            >
                                <option value={statusMapping.Pending}>Pending</option>
                                <option value={statusMapping.Approved}>Approved</option>
                                <option value={statusMapping.Rejected}>Rejected</option>
                            </select>
                        </div>
                    </div>
                    <Table className="vendor-table-modern">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>Contact Person</th>
                                <th>Nature of Supply</th>
                                <th>MSME</th>
                                <th>PAN</th>
                                <th>GST</th>
                                <th>HSN/SAC</th>
                                <th
                                    onClick={() => handleSort("approvalStatus")}
                                    style={{ cursor: "pointer" }}
                                >
                                    Approval Status {sortBy === "approvalStatus"
                                        ? (sortOrder === "asc" ? "▲" : "▼")
                                        : "⇅"}
                                </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendorsForPage.length === 0 ? (
                                <tr>
                                    <td colSpan="10" className="no-data">
                                        No vendors found
                                    </td>
                                </tr>
                            ) : (
                                vendorsForPage.map((vendor, index) => (
                                    <tr key={vendor.vendorCode || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td className="company">{vendor.nameOfCompany}</td>
                                        <td>{vendor.contactPersonName || "N/A"}</td>
                                        <td>{vendor.natureOfSupply}</td>
                                        <td>{vendor.msmeNo || "N/A"}</td>
                                        <td>{vendor.pan || "N/A"}</td>
                                        <td>{vendor.gst || "N/A"}</td>
                                        <td>{vendor.hsNsacCode || "N/A"}</td>
                                        {/* Status Badge */}
                                        <td>
                                            {(() => {
                                                const label =
                                                    vendor.approvalStatus === "1"
                                                        ? "Approved"
                                                        : vendor.approvalStatus === "2"
                                                            ? "Rejected"
                                                            : vendor.approvalStatus === "3"
                                                                ? "Pending"
                                                                : vendor.approvalStatus || "N/A";

                                                return (
                                                    <span
                                                        style={{
                                                            fontSize: "13px",
                                                            fontWeight: 500,
                                                            color: getStatusStyle(label),
                                                        }}
                                                    >
                                                        {label}
                                                    </span>
                                                );
                                            })()}
                                        </td>
                                        {/* Action Button */}
                                        <td>
                                            <button
                                                className="review-btn"
                                                onClick={() => handleReviewClick(startIndex + index)}
                                            >
                                                Review
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                    <div className="pagination-modern">
                        <button
                            onClick={() => handlePageChange("first")}
                            disabled={currentPage === 1}
                        >
                            ⏮
                        </button>
                        <button
                            onClick={() => handlePageChange("prev")}
                            disabled={currentPage === 1}
                        >
                            ◀
                        </button>
                        <span className="page-info">
                            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                        </span>
                        <button
                            onClick={() => handlePageChange("next")}
                            disabled={currentPage === totalPages}
                        >
                            ▶
                        </button>
                        <button
                            onClick={() => handlePageChange("last")}
                            disabled={currentPage === totalPages}
                        >
                            ⏭
                        </button>
                    </div>
                </Container>
                <Modal isOpen={showAuthModal} toggle={() => setShowAuthModal(false)} centered>
                    <ModalHeader toggle={() => setShowAuthModal(false)}>
                        Authentication Required
                    </ModalHeader>
                    <Modal
                        isOpen={showAuthModal}
                        toggle={() => setShowAuthModal(false)}
                        centered
                        className="auth-modal"
                    >
                        <ModalHeader toggle={() => setShowAuthModal(false)}>
                            🔐 SAGE Authentication Required
                        </ModalHeader>
                        <ModalBody>
                            <div className="auth-containers">
                                {/* Username */}
                                <div className="form-group">
                                    <label>Username <span className="required">*</span></label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        className={`input-modern ${usernameError ? "input-error" : ""}`}
                                    />
                                    {usernameError && <div className="error-text">{usernameError}</div>}
                                </div>
                                {/* Password */}
                                <div className="form-group">
                                    <label>Password <span className="required">*</span></label>
                                    <Input
                                        type="password"
                                        placeholder="Enter Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className={`input-modern ${passwordError ? "input-error" : ""}`}
                                    />
                                    {passwordError && <div className="error-text">{passwordError}</div>}
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => setShowAuthModal(false)}>
                                Close
                            </Button>
                            <Button
                                color="primary"
                                onClick={() => {
                                    let isValid = true;
                                    setUsernameError("");
                                    setPasswordError("");
                                    if (!username) {
                                        setUsernameError("Username is required");
                                        isValid = false;
                                    }
                                    if (!password) {
                                        setPasswordError("Password is required");
                                        isValid = false;
                                    }
                                    if (!isValid) return;
                                    handleSave(username, password);
                                    setShowAuthModal(false);
                                }}
                            >
                                Submit
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Modal>
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                    <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                    <div className="tabs1">
                        <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                        <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                        <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>
                    </div>
                    <ModalBody>
                        {activeTab === "history" && selectedVendor && (
                            <div className="history-container">
                                <Table bordered className="history-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Approval Status</th>
                                            <th>Approver Name</th>
                                            <th>Date</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.length > 0 ? (
                                            users.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    {/* <td>{user.ApprovalStatus || "N/A"}</td>*/}
                                                    <td>{user.approvalStatus || "N/A"}</td>
                                                    <td>{user.approvalName || "N/A"}</td>
                                                    <td>
                                                        {user.createDate
                                                            ? (() => {
                                                                const date = new Date(user.createDate);
                                                                const day = String(date.getDate()).padStart(2, "0");
                                                                const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                const year = date.getFullYear();
                                                                const hours = String(date.getHours()).padStart(2, "0");
                                                                const minutes = String(date.getMinutes()).padStart(2, "0");
                                                                const seconds = String(date.getSeconds()).padStart(2, "0");
                                                                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                                            })()
                                                            : "N/A"}
                                                    </td>
                                                    <td>{user.comments || "N/A"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No history found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                        {activeTab === "info" && selectedVendor && (
                            <VendorInfoTabs
                                selectedVendor={selectedVendor}
                                isEditing={isEditing}
                                setIsEditing={setIsEditing}
                                handleInputChange={handleInputChange}
                                subTab={subTab}
                                setSubTab={setSubTab}
                                type="vendor"
                            />
                        )}
                        {activeTab === "details" && selectedVendor && (
                            <div className="details-container">
                                <>
                                    <Table bordered className="info-table1">
                                        <tbody>
                                            <tr>
                                                <th>Approval Status:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.approvalStatus || ""}
                                                        disabled={isReadOnly}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                approvalStatus: value,
                                                                rejectionSendTo: value === "2" ? selectedVendor.rejectionSendTo : "",
                                                            });
                                                            setApprovalStatusError("");
                                                            setRejectionSendToError("");
                                                        }}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="1">Approved</option>
                                                        <option value="2">Rejected</option>
                                                    </Input>
                                                    {approvalStatusError && (
                                                        <div className="text-danger">{approvalStatusError}</div>
                                                    )}
                                                </td>
                                                <th>Comments:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="textarea"
                                                        className="full-width-dropdown"
                                                        value={comment || ""}
                                                        disabled={isReadOnly}
                                                        placeholder="Enter rejection comments..."
                                                        //  {/* onChange={(e) => setComment(e.target.value)}*/}
                                                        onChange={(e) => {
                                                            setComment(e.target.value);
                                                            setCommentError("");   // 👈 clear validation error
                                                        }}
                                                    />
                                                    {commentError && <div className="text-danger">{commentError}</div>}
                                                </td>
                                            </tr>
                                            {isRejected && (
                                                <tr>
                                                    <th>Rejection Send To:<span className="required-field">*</span></th>
                                                    <td>
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            value={selectedVendor?.rejectionSendTo || ""}
                                                            disabled={
                                                                selectedVendor?.approvalStatus !== "2" || selectedVendor?.isSaved || isReadOnly
                                                            } // 👈 disable unless Rejected
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const sendToName =
                                                                    value === "1" ? "Finance" :
                                                                        value === "2" ? "Dept Head" :
                                                                            value === "3" ? "PO" :
                                                                                value === "4" ? "Vendor" : "";
                                                                setSelectedVendor({
                                                                    ...selectedVendor,
                                                                    rejectionSendTo: value,
                                                                    rejectionSendToName: sendToName
                                                                });
                                                                setRejectionSendToError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1">Finance</option>
                                                            <option value="2">Dept Head</option>
                                                            <option value="3">PO</option>
                                                            <option value="4">Vendor</option>
                                                        </Input>
                                                        {rejectionSendToError && (
                                                            <div className="text-danger">{rejectionSendToError}</div>
                                                        )}
                                                    </td>
                                                    <th></th>
                                                    <td></td>
                                                </tr>
                                            )}
                                            {/* =======================
                                            ALL NORMAL FIELDS
                                            (HIDDEN WHEN REJECTED)
                                            ======================= */}
                                            {!isRejected && (
                                                <>
                                                    <tr>
                                                        <th>Name of Company:</th>
                                                        <td>{selectedVendor?.nameOfCompany || "N/A"}</td>
                                                        <th>Group Code:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.groupCode || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) => {
                                                                    const code = e.target.value;
                                                                    const selected = groupCodes.find(x => x.groupcode === code);
                                                                    setSelectedVendor(prev => ({
                                                                        ...prev,
                                                                        groupCode: code,
                                                                        groupName: selected?.description || ""
                                                                    }));
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {groupCodes.map(item => (
                                                                    <option key={item.groupcode} value={item.groupcode}>
                                                                        {item.groupcode} - {item.description}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {selectedVendor?.groupCode && (
                                                                <Input
                                                                    type="text"
                                                                    disabled
                                                                    value={selectedVendor?.groupName || ""}
                                                                    style={{ marginTop: "10px", width: "170px" }}
                                                                />
                                                            )}
                                                            {groupCodeError && <div className="text-danger">{groupCodeError}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Account Set:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.accountSetCode || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) =>
                                                                    setSelectedVendor({ ...selectedVendor, accountSetCode: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {accountSets.map(item => (
                                                                    <option key={item.accountSetCode} value={item.accountSetCode}>
                                                                        {item.description}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {accountSetError && <div className="text-danger">{accountSetError}</div>}
                                                        </td>
                                                        <th>Tax Groups:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.taxGroup || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) =>
                                                                    setSelectedVendor({ ...selectedVendor, taxGroup: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {taxGroups.map(item => (
                                                                    <option key={item.taxGroup} value={item.taxGroup}>
                                                                        {item.description}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {taxGroupsError && <div className="text-danger">{taxGroupsError}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Department Type:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.departmentType || ""}
                                                                disabled={isReadOnly}
                                                                onChange={handleDepartmentChange}
                                                            >
                                                                <option value="">Select</option>
                                                                {departments.map(dept => (
                                                                    <option key={dept.id} value={dept.id}>
                                                                        {dept.name}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {departmentTypeError && <div className="text-danger">{departmentTypeError}</div>}
                                                        </td>
                                                        <th>Supplier Type:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.supplierType?.toString() || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) =>
                                                                    setSelectedVendor({ ...selectedVendor, supplierType: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {supplierTypes.map(s => (
                                                                    <option key={s.id} value={s.id.toString()}>
                                                                        {s.name}
                                                                    </option>
                                                                ))}
                                                            </Input>
                                                            {supplierTypeError && <div className="text-danger">{supplierTypeError}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Terms Code:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.termsCode || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) =>
                                                                    setSelectedVendor({ ...selectedVendor, termsCode: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="DEF">DEF</option>
                                                                <option value="NET15">NET15</option>
                                                                <option value="NET20">NET20</option>
                                                                <option value="NET30">NET30</option>
                                                                <option value="NET45">NET45</option>
                                                            </Input>
                                                            {termsCodeError && <div className="text-danger">{termsCodeError}</div>}
                                                        </td>
                                                        <th>Vendor Code:</th>
                                                        <td>
                                                            <FormGroup check inline>
                                                                <Label check>
                                                                    <Input
                                                                        type="checkbox"
                                                                        disabled={isReadOnly}
                                                                        checked={!!isExisting}
                                                                        onChange={(e) => {
                                                                            const checked = e.target.checked;
                                                                            setIsExisting(checked);
                                                                            if (!checked) {
                                                                                setVendorCode("");
                                                                                setSelectedVendor(prev => ({
                                                                                    ...prev,
                                                                                    vendorCode: ""
                                                                                }));
                                                                            }
                                                                        }}
                                                                    />
                                                                    Existing
                                                                </Label>
                                                            </FormGroup>
                                                            {isExisting && (
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Enter Vendor Code"
                                                                    value={vendorCode || ""}
                                                                    disabled={isReadOnly}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value || "";
                                                                        setVendorCode(value);
                                                                        setSelectedVendor(prev => ({
                                                                            ...prev,
                                                                            vendorCode: value
                                                                        }));
                                                                    }}
                                                                    style={{ marginTop: "10px", width: "150px" }}
                                                                />
                                                            )}
                                                            {vendorCodeError && (
                                                                <div className="text-danger">{vendorCodeError}</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>ISD:<span className="required-field">*</span></th>
                                                        <td>
                                                            <Input
                                                                type="select"
                                                                className="full-width-dropdown"
                                                                value={selectedVendor?.isd || ""}
                                                                disabled={isReadOnly}
                                                                onChange={(e) =>
                                                                    setSelectedVendor({ ...selectedVendor, isd: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">YES</option>
                                                                <option value="2">NA</option>
                                                            </Input>
                                                            {isdError && <div className="text-danger">{isdError}</div>}
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </Table>
                                    <ModalFooter>
                                        {!isReadOnly && (
                                            <>
                                                <Button color="primary" onClick={handleUpdate}>Update</Button>
                                                {!isSaved && (
                                                    <Button
                                                        color="success"
                                                        onClick={() => {
                                                            // Step 1: Validate all fields
                                                            if (!validateForm()) return;
                                                            // Step 2: Allow popup ONLY if Approved
                                                            if (selectedVendor?.approvalStatus !== "1") {
                                                                setApprovalStatusError("Popup allowed only when status is Approved");
                                                                return;
                                                            }
                                                            setUsername("");
                                                            setPassword("");
                                                            setUsernameError("");
                                                            setPasswordError("");
                                                            // ✅ Step 3: Open popup
                                                            setShowAuthModal(true);
                                                        }}
                                                    >
                                                        Save
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                        <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                                    </ModalFooter>
                                </>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </DashboardLayout>
    );
};
export default ViewAllVendorsCFO;
